"use client";
import { FooterData } from "../lib/features/footer/footer.types";
import { setFooter } from "../lib/features/footer/footer.slice";
import { store } from "../lib/store";

interface FooterInitializerProviderProps {
  initialFooter?: FooterData | null;
}

/**
 * SSR'dan gelen footer verisini mount öncesi Redux store'a senkron yazar.
 * HeaderInitializerProvider ile aynı pattern:
 * - initialFooter varsa → store'a senkron yaz, AppEffects'deki getFooter() skip eder
 *   (footer.thunk condition: data varsa return false).
 * - initialFooter yoksa → AppEffects getFooter() normal akışla çeker.
 */
const FooterInitializerProvider = ({ initialFooter }: FooterInitializerProviderProps) => {
  if (initialFooter && !store.getState().footer.data) {
    store.dispatch(setFooter(initialFooter));
  }
  return null;
};

export default FooterInitializerProvider;